import { Mail, Instagram } from "lucide-react";
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "./brand";

const channels = [
  { id: "email", label: "Email", text: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}`, icon: Mail },
  { id: "instagram", label: "Instagram", text: INSTAGRAM_HANDLE, href: INSTAGRAM_URL, icon: Instagram, external: true },
];

export const ContactDetails = () => (
  <div className="mt-10 space-y-4">
    {channels.map(({ id, label, text, href, icon: Icon, external }) => (
      <a key={id} href={href} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined}
        data-testid={`contact-${id}-link`} className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-[#101018] p-5 transition-colors hover:border-[#00E5FF]/50">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/5 text-[#00E5FF]"><Icon className="h-5 w-5" /></div>
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-wide text-zinc-500">{label}</div>
          <div data-testid={`contact-${id}-text`} className="break-words text-sm font-medium text-white">{text}</div>
        </div>
      </a>
    ))}
  </div>
);